import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@crono-one/design-system';
import { Event } from 'crono-fe-common/types/event';
import {
  MeetingActionId,
  useMeetingActions,
} from 'pages/accountDrawer/hooks/useMeetingActions';
import { ComponentProps, ReactElement } from 'react';

const ITEM_VARIANTS: Partial<
  Record<MeetingActionId, ComponentProps<typeof DropdownMenuItem>['variant']>
> = {
  delete: 'red',
};

interface MeetingDropdownActionsProps {
  event?: Event | null;
  includeJoin?: boolean;
  trigger: ReactElement;
}

const MeetingDropdownActions = ({
  event,
  includeJoin,
  trigger,
}: MeetingDropdownActionsProps) => {
  const { actions, joinAction } = useMeetingActions(event);

  const menuActions =
    includeJoin && joinAction ? [joinAction, ...actions] : actions;

  if (!menuActions.length) {
    return null;
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger render={trigger} />

      <DropdownMenuContent positionerClassname="z-50000">
        <DropdownMenuGroup>
          {menuActions.map(({ id, action, label, Icon }) => (
            <DropdownMenuItem
              key={id}
              onClick={action}
              variant={ITEM_VARIANTS[id]}
            >
              {label}

              <Icon className="size-6 ml-auto" />
            </DropdownMenuItem>
          ))}
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default MeetingDropdownActions;
